import { render, staticRenderFns } from "./Materials_version2.vue?vue&type=template&id=50a4d137"
import script from "./Materials_version2.vue?vue&type=script&lang=js"
export * from "./Materials_version2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports